import { HTMLAttributes, memo } from 'react';
import cls from 'classnames';

import styles from './Loader.module.css';

export const BLACK = 'black';
export const WHITE = 'white';
export const COLORED = 'colored';

const APPEARANCE_CLASS_MAP = {
  [BLACK]: styles.loaderBlack,
  [WHITE]: styles.loaderWhite,
  [COLORED]: styles.loaderColored,
};

export const LARGE = 'large';
export const MEDIUM = 'medium';
export const SMALL = 'small';
export const X_SMALL = 'x-small';

const SIZE_CLASS_MAP = {
  [LARGE]: styles.loaderLarge,
  [MEDIUM]: styles.loaderMedium,
  [SMALL]: styles.loaderSmall,
  [X_SMALL]: styles.loaderXSmall,
};

export type LoaderAppearanceType = keyof typeof APPEARANCE_CLASS_MAP;
type LoaderSizeType = keyof typeof SIZE_CLASS_MAP;

interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  appearance?: LoaderAppearanceType;
  size?: LoaderSizeType;
}

function Loader(props: LoaderProps) {
  const { appearance = COLORED, size = LARGE, className, ...rest } = props;

  return (
    <div
      aria-label="Loader"
      className={cls(
        styles.loader,
        appearance && APPEARANCE_CLASS_MAP[appearance],
        size && SIZE_CLASS_MAP[size],
        className,
      )}
      {...rest}
    >
      <span />

      <span />

      <span />
    </div>
  );
}

export default memo(Loader);
